/* eslint-disable import/prefer-default-export */
import { useCallback, useState } from 'react';

import { providerSort } from '../utils/consts';

/** @typedef {'location' | 'provider'} SortType */
export const useSort = () => {
  /** @type {[SortType, React.Dispatch<React.SetStateAction<SortType>>]} */
  const [sortType, setSortType] = useState(providerSort);

  const changeSortType = useCallback(
    /** @param {SortType} newSortType */ (newSortType) => setSortType(newSortType),
    []
  );

  return { changeSortType, sortType };
};
